import { useGetMoreOrders } from '../../../lib/react-query/statsQuery';
import StatsChart from './StatsChart';

const MoreOrders = () => {
  const { data: articulos, isLoading } = useGetMoreOrders();
  return <StatsChart data={articulos} keys={{ cantidad: 'Cantidad', importe: 'Importe' }} isLoading={isLoading} />;
};

export default MoreOrders;
